import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SettingsIcon from "@mui/icons-material/Settings";
import { logout } from "../../actions/auth";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import LogoutIcon from "@mui/icons-material/Logout";
import { useLocation, Link } from "react-router-dom";
import Button from "@mui/material/Button";
import { useState } from "react";
import ParameterModal from "../parameters/ParameterModal";
import Person2Icon from '@mui/icons-material/Person2';

function NavBar_v2() {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [parameterModalShow, setParameterModalShow] = useState(false);
  const updateParameterModalShow = (show) => { setParameterModalShow(show) }

  const getCurrentTab = () => {
    const currentLoc = location.pathname;
    switch (currentLoc) {
      case "/Booking":
        return 0;
      case "/users-management":
        return 1;
      case "/agencies-management":
        return 2;
      case "/centers-management":
        return 3;
      case "/bookings-management":
        return 4;
    }
  };

  const [value, setValue] = React.useState(getCurrentTab());
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const { user: currentUser } = useSelector((state) => state.auth);


  const logOut = () => {
    dispatch(logout());
    navigate("/");
  };
  const logIn = () => {
    navigate("/");
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event, index) => {
    setValue(index);
    switch (index) {
      case 0:
        navigate("/Booking");
        break;
      case 1:
        navigate("/users-management");
        break;
      case 2:
        navigate("/agencies-management");
        break;
      case 3:
        navigate("/centers-management");
        break;
      case 4:
        navigate("/bookings-management");
        break;
      case 5:
        navigate("/statistics");
        break;
    }
  };

  return location.pathname === "/" || location.pathname === "/create-account" ? null : (
    <>
      <AppBar position="static" color="primary">
        <Toolbar>
          <Box sx={{ width: "100%" }}>
            {currentUser ? (
              <Tabs value={value} onChange={handleChange} textColor="red" indicatorColor="primary" centered

                TabIndicatorProps={{
                  style: {
                    backgroundColor: "white"
                  }
                }} >
                <Tab value={0} label="New enrolment" />
                <Tab value={4} label="Bookings" />
                {currentUser.type != 4 && currentUser.type != 2 && <Tab value={1} label="Users" />}
                {currentUser.type == 1 && <Tab value={2} label="Agencies" />}
                {currentUser.type != 4 && currentUser.type != 3 && <Tab value={3} label="Centres" />}
                {(currentUser.type == 1 || currentUser.type == 2) && <Tab value={5} label="Statistics" />}
              </Tabs>
            ) : (
              <></>
            )}
          </Box>

          {currentUser ? (
            <>
              <IconButton size="large" color="inherit">
                <Badge badgeContent={0} color="error">
                  <AccountCircleIcon onClick={handleClick} />
                  <Menu anchorEl={anchorEl} open={open} onClose={handleClose} PaperProps={{ style: { width: 160 } }}>
                    <MenuItem
                      onClick={() => {
                        updateParameterModalShow(true);
                        handleClose();
                      }}>
                      <ListItemIcon>
                        <SettingsIcon />
                      </ListItemIcon>
                      <ListItemText>Settings</ListItemText>
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleClose();
                        logOut();
                      }}>
                      <ListItemIcon>
                        <LogoutIcon />
                      </ListItemIcon>
                      <ListItemText>Log out</ListItemText>
                    </MenuItem>
                  </Menu>
                </Badge>
              </IconButton>
            </>
          ) : (
            <>
              <Button variant="text" color="secondary" onClick={logIn}>
                Login
              </Button>
            </>
          )}
        </Toolbar>
      </AppBar>
      <ParameterModal show={parameterModalShow} onHide={() => updateParameterModalShow(false)} />
    </>
  );
}
export default NavBar_v2;
